unable to read source [project]/node_modules/.pnpm/@inngest+ai@0.1.7/node_modules/@inngest/ai/src/models/deepseek.ts